import { render } from "./variant-collection-buttons.vue?vue&type=template&id=1b627ea0"
import script from "./variant-collection-buttons.vue?vue&type=script&lang=js"
export * from "./variant-collection-buttons.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Work/Sneak-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__